import { render, staticRenderFns } from "./kpi.vue?vue&type=template&id=5ad5e88b&scoped=true"
import script from "./kpi.vue?vue&type=script&lang=js"
export * from "./kpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad5e88b",
  null
  
)

export default component.exports